import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import type { RevenueMethod } from '../../../../../AudienceForm/constants.ts';
import { revenueMethodValues } from './types.ts';

type AllowedOrganizationItemProps = {
  name: string;
  fee: null | string;
  method: RevenueMethod;
};

export function AllowedOrganizationItem({ name = '', fee = null, method }: AllowedOrganizationItemProps) {
  const { t } = useTranslation();

  return (
    <Stack>
      <Typography variant="body1Bold">{name}</Typography>
      {fee !== null && (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: 'center',
          }}
        >
          <Typography variant="body2" color="textSecondary">
            {t(method === revenueMethodValues.CPM ? 'CPM' : 'Fee')}:
          </Typography>
          <Typography variant="body1">
            {fee}
            {method === revenueMethodValues.CPM ? '$' : '%'}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
}
